import React from 'react'
import Form from 'react-bootstrap/Form'
import Button from '../../../common/components/Button'

import {axiosGet} from '../../../common/js/axios-utility';
import { CrumplePopSignupContext } from '../../contexts/CrumplePopSignupContext';

export default function CrumplePopEmailEntry(props) {
    const {onComplete, hideButton} = props;

    const email = React.useRef('');
    const [migrationState, setMigrationState] = React.useContext(CrumplePopSignupContext);
    const [isProcessing, setIsProcessing] = React.useState(false);
    const [error, setError] = React.useState(null);
    const externalCallbackRef = React.useRef(null);

    React.useEffect(() => {
        externalCallbackRef.current = handleNext;
    }, [email])

    React.useEffect(() => {
        if (hideButton){
            const callback = e => externalCallbackRef.current(e);
            window.addEventListener('login-external-email-submit', callback);
        }
    }, [hideButton])
    
    const handleNext = async event => {
        event.preventDefault();
        setMigrationState({...migrationState, processing: true});
        try{
            setError(null);
            const res = await axiosGet(`/cpop/email?email=${email.current}`);
            if (res.data.length > 0){
                onComplete(email.current);
            }
            else{
                throw Exception('no user found');
            }
        }
        catch(err){
            console.error(err);
            setError('No CrumplePop user found for this email address.');
            setMigrationState({...migrationState, processing: false});
        }
    }

    const handleEmailChange = event => {
        email.current = event.target.value;
    }

    return (
        <div className="email-signin-container">
            <form onSubmit={handleNext}>
                <div className='login-field'>
                    <label>Your email address</label>
                    <input name="email" type="email" autoComplete='email' onChange={handleEmailChange} />
                </div>
                <div className='email-signin-error'>
                    {error && (<span>{error}</span>)}
                </div>
                <div className="d-flex w-100 justify-content-end">
                    {!hideButton &&(
                        <Button className='btn-new cpop-submit-button' label="Continue" processing={migrationState.processing} submit />
                    )}
                </div>
            </form>
        </div>
    )
}
